// extracted by mini-css-extract-plugin
export default {"title":"Workplace_title__U2uJd","link":"Workplace_link__ib8HN"};